module.exports = __webpack_public_path__ + "static/media/TranscendLife3.9c138209.jpg";